export const CATALOGUE_LABEL_ROW_HEIGHT = 50;

export const CATALOGUE_LABEL_OVERSACN_COUNT = 5;
